// extracted by mini-css-extract-plugin
module.exports = {"link":"propertyUnitsCard_link__3V10P","img":"propertyUnitsCard_img__CK4Tv","titleUnit":"propertyUnitsCard_titleUnit__19sTN","tilde":"propertyUnitsCard_tilde__1-DMI","surface":"propertyUnitsCard_surface__5ynKG","price":"propertyUnitsCard_price__1WWZW","contentCard":"propertyUnitsCard_contentCard__2LvaO","notDisplayedPrice":"propertyUnitsCard_notDisplayedPrice__11aO1","rowSurface":"propertyUnitsCard_rowSurface__1aEju","icon":"propertyUnitsCard_icon__-ucLb"};
    if(module.hot) {
      // 1745908360749
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  